export default __webpack_public_path__ + "static/footer_bg-b6fc979434991ca2d3c63028f2613ad1.jpg";